import React from 'react';
import { useComplianceCountry } from '../../../hooks/useComplianceCountry';
import { KsaWpsCenter } from './KsaWpsCenter';
import { UaeWpsCenter } from './UaeWpsCenter';

// The two countries share a route and nothing else that matters: UAE runs on the per-employee file record and the
// MR 340/2026 clock, KSA on Mudad. Compliance country None keeps the KSA page's shell, whose routes answer 404.
const WpsCenter: React.FC = () => {
  const country = useComplianceCountry();
  return country === 'UAE' ? <UaeWpsCenter /> : <KsaWpsCenter />;
};

export default WpsCenter;
